<div class="suivi-page">
  <div class="suivi-card">
    <h1>Suivi de commande</h1>
    <p class="intro">Entrez le <strong>numéro de commande</strong> ou le <strong>numéro de suivi</strong> reçu lors de la création de l'envoi.</p>

    <div class="row-form">
      <input type="text" class="inp" [(ngModel)]="numero" placeholder="Ex. CMD-26-04-00042" (keyup.enter)="rechercher()" />
      <button type="button" class="btn-primary" (click)="rechercher()" [disabled]="chargement">
        {{ chargement ? 'Recherche…' : 'Suivre' }}
      </button>
    </div>

    <p class="err" *ngIf="erreur">{{ erreur }}</p>

    <div *ngIf="commande" class="resultat">
      <h2>Référence : <span class="mono">{{ referenceCommande }}</span></h2>
      <p><strong>Statut :</strong> {{ commande.statut || commande.status }}</p>
      <p *ngIf="commande.livreurNom"><strong>Livreur :</strong> {{ commande.livreurNom }}</p>
      <p *ngIf="commande.telephoneLivreur"><strong>Téléphone livreur :</strong> {{ commande.telephoneLivreur }}</p>
      <p *ngIf="commande.dateLivraison"><strong>Date de livraison :</strong> {{ commande.dateLivraison | date:'dd/MM/yyyy HH:mm' }}</p>

      <h3>Progression</h3>
      <ol class="etapes">
        <li *ngFor="let e of etapesAffichage" [class.atteinte]="e.atteinte">
          <span class="pastille"></span>
          {{ e.libelle }}
        </li>
      </ol>
    </div>

    <p class="footer-lien">
      <a routerLink="/connexion">Connexion</a>
    </p>
  </div>
</div>
